import { type ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn, defaultSizesForIcons } from "@genuin/ui/lib/utils";

// Define the unmuteVariant function using cva to handle different styles based on props
const unmuteVariant = cva("", {
  variants: {
    theme: {
      light: "gencl:fill-black", // Light variant style
      dark: "gencl:fill-white", // Dark variant style
    },
    size: defaultSizesForIcons(),
  },
  defaultVariants: {
    theme: "light", // Default to light theme
    size: "md", // Default size
  },
});

type Props = ComponentProps<"svg"> & VariantProps<typeof unmuteVariant>;

export function UnmuteIcon({
  theme = "light",
  size = "md",
  className,
  ...restProps
}: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(unmuteVariant({ theme, size }), className)}
      {...restProps}
    >
      <path d="M12.1171 2.29579L6.31346 8.22531C6.26387 8.26852 6.20117 8.29322 6.1358 8.29531H3.97424C3.4507 8.29531 2.94859 8.506 2.57839 8.88104C2.20819 9.25609 2.00021 9.76475 2.00021 10.2951V13.7149C2.00021 14.2453 2.20819 14.7539 2.57839 15.129C2.94859 15.504 3.4507 15.7147 3.97424 15.7147H6.1358C6.16858 15.7133 6.2013 15.7187 6.23189 15.7308C6.26247 15.7428 6.29025 15.7612 6.31346 15.7847L12.1171 21.7042C12.2546 21.8446 12.43 21.9406 12.6213 21.98C12.8126 22.0194 13.0112 22.0004 13.1918 21.9255C13.3725 21.8505 13.5271 21.723 13.6363 21.5591C13.7454 21.3951 13.8041 21.202 13.8049 21.0043V3.00573C13.806 2.80713 13.7488 2.61267 13.6404 2.44717C13.532 2.28166 13.3774 2.1526 13.1964 2.07644C13.0153 2.00028 12.816 1.98047 12.6237 2.01953C12.4315 2.0586 12.2552 2.15477 12.1171 2.29579Z" />
      <path d="M18.5143 6.24774C18.4349 6.17098 18.3403 6.11005 18.2362 6.06848C18.132 6.0269 18.0203 6.00549 17.9075 6.00549C17.7947 6.00549 17.683 6.0269 17.5788 6.06848C17.4747 6.11005 17.3801 6.17098 17.3007 6.24774C17.1415 6.40118 17.0522 6.60875 17.0522 6.8251C17.0522 7.04146 17.1415 7.24903 17.3007 7.40247C17.9323 8.00645 18.4333 8.72386 18.7752 9.51362C19.1171 10.3034 19.2931 11.15 19.2931 12.005C19.2931 12.86 19.1171 13.7066 18.7752 14.4964C18.4333 15.2862 17.9323 16.0036 17.3007 16.6075C17.1415 16.761 17.0522 16.9686 17.0522 17.1849C17.0522 17.4013 17.1415 17.6088 17.3007 17.7623C17.3801 17.839 17.4747 17.9 17.5788 17.9415C17.683 17.9831 17.7947 18.0045 17.9075 18.0045C18.0203 18.0045 18.132 17.9831 18.2362 17.9415C18.3403 17.9 18.4349 17.839 18.5143 17.7623C20.1061 16.2345 21.0002 14.1639 21.0002 12.005C21.0002 9.84615 20.1061 7.77552 18.5143 6.24774Z" />
      <path d="M16.4962 8.252C16.4195 8.17423 16.3282 8.11244 16.2278 8.07015C16.1273 8.02785 16.0195 8.00589 15.9106 8.0055C15.8017 8.00511 15.6938 8.02631 15.593 8.06789C15.4922 8.10947 15.4006 8.17061 15.3233 8.24783C15.246 8.32504 15.1846 8.41682 15.1426 8.51791C15.1005 8.61901 15.0787 8.72744 15.0783 8.83703C15.0779 8.94662 15.099 9.0552 15.1403 9.1566C15.1817 9.25799 15.2424 9.3502 15.3192 9.42796C15.9964 10.1125 16.3766 11.0391 16.3766 12.0051C16.3766 12.971 15.9964 13.8976 15.3192 14.5822C15.1648 14.7384 15.0781 14.9498 15.0781 15.1702C15.0781 15.3905 15.1648 15.6019 15.3192 15.7581C15.3962 15.8363 15.4879 15.8984 15.5889 15.9407C15.6899 15.983 15.7983 16.0048 15.9077 16.0048C16.0171 16.0048 16.1254 15.983 16.2265 15.9407C16.3275 15.8984 16.4191 15.8363 16.4962 15.7581C17.4842 14.7621 18.0392 13.4123 18.0392 12.0051C18.0392 10.5978 17.4842 9.24803 16.4962 8.252Z" />
    </svg>
  );
}
